<template>
  <b-navbar>
    <template slot="brand">
      <b-navbar-item
        tag="router-link"
        :to="{ path: '/' }">
        <img
          src="../assets/TrollingTraff-blackandblue-e1456176509215.jpg"
          alt="Trollingträffen">
      </b-navbar-item>
    </template>

    <template slot="end">
      <div class="buttons">
        <b-navbar-item
          v-if="!loggedIn"
          tag="div">
          <router-link
            class="button is-light"
            :to="{ name: 'login'}">
            <translate>Logga in</translate>
          </router-link>
        </b-navbar-item>
        <b-navbar-item
          v-if="!live"
          class="button is-light"
          @click="lang('en_US')">
          <span class="flag-icon flag-icon-gb" />
        </b-navbar-item>
        <b-navbar-item
          v-if="!live"
          class="button is-light"
          @click="lang('sv-SE')">
          <span class="flag-icon flag-icon-ax" />
        </b-navbar-item>
        <b-navbar-item
          v-if="loggedIn"
          tag="div">
          <button
            v-if="user"
            class="button is-light">
            {{ user.name }}
          </button>
          <button
            class="button is-light"
            @click="logout">
            <translate>Logga ut</translate>
          </button>
        </b-navbar-item>
      </div>
    </template>
  </b-navbar>
</template>

<script>

import Vue from 'vue'

export default {
  name: 'NavBar',
  data () {
    return {
    }
  },
  computed: {
    loggedIn () {
      return this.$store.state.authentication.status.loggedIn;
    },
    user () {
      return this.$store.state.authentication.token
    },
    live () {
      if (this.$router.currentRoute.matched[0].path == '/live/:id/day/:dayId'){
        return true
      }
      return false
    },
  },
  created () {
  },
  methods: {
    logout: function (){
      this.$store.dispatch('authentication/logout');
    },
    lang: function(language){
      Vue.config.language = language
    },
  },
}
</script>
